'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {I18nMessage} from '../../../../components/I18nMessage/index';
import {AppNavigationLayout} from '../../../../components/views/AppNavigationLayout';
import {OrgList} from '../../../../organizations/components/OrgList';
import {AppNavigationOrgsFilter} from './AppNavigationOrgsFilter';


export function AppNavigationOrgsView(props) {
  return (
    <AppNavigationLayout
      className={classNames("AppNavigationOrgs", props.className)}
      showBack={false}
      headerLabelContent={<I18nMessage message="organizations.nav.banner.title" />}
      headerDescriptionContent={<I18nMessage message="organizations.nav.banner.description" />}
      filterComponent={<AppNavigationOrgsFilter parentId={props.parentId} />}
      onLoadMore={props.onLoadMore}
      mode={props.mode}
    >
      <OrgList
        className="AppNavigationOrgs__list"
        useScroll={false}
        userId={props.userId}
        list={props.list}
        mode={props.mode}
        hasMore={props.hasMore}
        onClickItem={props.onClickItem}
        onItemShowOptions={props.onItemShowOptions}
      />
    </AppNavigationLayout>
  );
}

AppNavigationOrgsView.propTypes = {
  className: T.string,
  onClickItem: T.func.isRequired,
  onItemShowOptions: T.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/app/navigation/components/AppNavigationOrgs/AppNavigationOrgsView.js